/**
 * 员工管理
 */

import { FullChildContainer } from '@acgn/herm/src/components';

const staffRoutes: any = {
  path: 'comic-staff',
  name: '员工管理',
  icon: 'ift-staff_2',
  meta: {
    breadcrumbHidden: true
  },
  component: FullChildContainer,
  children: [
    {
      path: '',
      redirect: 'list'
    },
    {
      path: 'list',
      redirect: 'list',
      name: '员工管理',
      component: FullChildContainer,
      children: [
        {
          path: ':project_id?',
          name: 'desk-staffList',
          meta: {
            text: '员工列表',
            type: 'list',
            role: ['2002']
          },
          component: () => import('../views/staff/list.vue')
        }
      ]
    },
    // {
    //   path: 'detail',
    //   name: 'desk-staffDetail',
    //   meta: {
    //     text: '员工详情',
    //     type: 'detail',
    //   },
    //   component: () => import('../views/staff/detail.vue')
    // },
  ]
};

export {
  staffRoutes
};
